var Ae = Object.defineProperty;
var De = (e, t, n) =>
  t in e
    ? Ae(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n })
    : (e[t] = n);
var et = (e, t, n) => De(e, typeof t != "symbol" ? t + "" : t, n);
const mt = "*",
  ft = "*:onError",
  F = { "*": [], "*:onError": [] },
  yt = {};
function Le(e, t, n = 0) {
  var s;
  const o = { unsubscribe: null, accepted: !1, overwrittenPriority: 0 },
    i = yt[e];
  if (!i || n > i.priority) {
    (s = i == null ? void 0 : i.unsubscribe) == null || s.call(i);
    const r = () => {
        var c;
        ((c = yt[e]) == null ? void 0 : c.callback) === t && delete yt[e];
      },
      a = { callback: t, priority: n, unsubscribe: r };
    ((yt[e] = a),
      (o.unsubscribe = r),
      (o.accepted = !0),
      (o.overwrittenPriority = i ? i.priority : 0));
  }
  return o;
}
function Oe(e, t) {
  if (e === mt) {
    const n = t;
    return (
      (F[mt] || (F[mt] = [])).push(n),
      () => {
        var o;
        F[mt] = (o = F[mt]) == null ? void 0 : o.filter((i) => i !== n);
      }
    );
  } else if (e === ft) {
    const n = t;
    return (
      (F[ft] || (F[ft] = [])).push(n),
      () => {
        var o;
        F[ft] = (o = F[ft]) == null ? void 0 : o.filter((i) => i !== n);
      }
    );
  } else {
    const n = t;
    return (
      (F[e] || (F[e] = [])).push(n),
      () => {
        const o = F[e];
        if (o) {
          const i = o;
          F[e] = i.filter((s) => s !== t);
        }
      }
    );
  }
}
function ue(e, t) {
  var n, o, i;
  ((n = F[e] || (F[e] = [])) == null ||
    n.forEach((s) => {
      try {
        s(t);
      } catch (r) {
        console.error(`Error in subscriber for event '${e}':`, r);
      }
    }),
    (o = F["*"] || (F["*"] = [])) == null ||
      o.forEach((s) => {
        const r = { eventName: e, data: t };
        try {
          s(r);
        } catch (a) {
          console.error(`Error in wildcard subscriber for event '${e}':`, a);
        }
      }),
    e.endsWith(":onError") &&
      ((i = F["*:onError"] || (F["*:onError"] = [])) == null ||
        i.forEach((s) => {
          const r = { eventName: e, data: t };
          try {
            s(r);
          } catch (a) {
            console.error(
              `Error in error-wildcard subscriber for event '${e}':`,
              a,
            );
          }
        })));
}
function de(e, t) {
  ue(e, t);
}
function Te(e, t, n = !1) {
  n || ue(e, t);
  const o = yt[e];
  return o != null && o.callback
    ? Promise.resolve(o.callback(t))
    : Promise.reject(
        new Error(`No command handler registered for event '${e}'`),
      );
}
function Pe() {
  [
    "shopify:section:load",
    "shopify:section:unload",
    "shopify:section:select",
    "shopify:section:deselect",
    "shopify:section:reorder",
    "shopify:block:select",
    "shopify:block:deselect",
    "shopify:inspector:activate",
    "shopify:inspector:deactivate",
  ].forEach((t) => {
    document.addEventListener(t, (n) => {
      var i, s;
      let o = {};
      ((i = n.detail) != null &&
        i.sectionId &&
        (o.sectionId = n.detail.sectionId),
        (s = n.detail) != null && s.blockId && (o.blockId = n.detail.blockId),
        de(t, o));
    });
  });
}
typeof window < "u" && Pe();
const N = {
  publish: de,
  subscribe: Oe,
  request: Te,
  handleRequest: Le,
  subscribers: F,
};
var ce, le;
const gt =
    ((le = (ce = window.Shopify) == null ? void 0 : ce.routes) == null
      ? void 0
      : le.root) || "/",
  me = {
    get: `${gt}cart.js`,
    add: `${gt}cart/add.js`,
    change: `${gt}cart/change.js`,
    update: `${gt}cart/update.js`,
    clear: `${gt}cart/clear.js`,
  };
let Ot = null;
function _e(e) {
  if (e) {
    if (e.sections && e.sections.length > 0) {
      const t = e.sections_url ?? window.location.pathname,
        n = t.startsWith("/") ? t : `/${t}`;
      return { ...e, sections_url: Ge(n) };
    }
    return e;
  }
}
async function fe() {
  const e = await fetch(me.get, {
    method: "GET",
    headers: { Accept: "application/json" },
    credentials: "same-origin",
  });
  if (!e.ok) {
    const t = await e.text().catch(() => "");
    throw new Error(
      `Cart Abruf fehlgeschlagen (${e.status}): ${t || e.statusText}`,
    );
  }
  return await e.json();
}
function te(e) {
  const t = new Map();
  for (const n of e)
    t.set(String(n.key), {
      q: n.quantity,
      lp: n.line_price,
      dp: n.discounted_price,
    });
  return t;
}
function Ne(e, t) {
  const n = Object.keys(e || {}),
    o = Object.keys(t || {});
  if (n.length !== o.length) return !1;
  for (const i of n) if (e[i] !== t[i]) return !1;
  return !0;
}
function Be(e, t) {
  if (
    !e ||
    e.item_count !== t.item_count ||
    e.total_price !== t.total_price ||
    e.total_discount !== t.total_discount ||
    e.items.length !== t.items.length
  )
    return !0;
  if (e.note !== t.note)
    return (
      N.publish("cart-note:onChanged", {
        previousNote: e.note,
        currentNote: t.note,
      }),
      !0
    );
  if (!Ne(e.attributes || {}, t.attributes || {})) return !0;
  const n = te(e.items),
    o = te(t.items);
  if (n.size !== o.size) return !0;
  for (const [i, s] of n) {
    const r = o.get(i);
    if (!r || s.q !== r.q || s.lp !== r.lp || s.dp !== r.dp) return !0;
  }
  return !1;
}
function Fe(e, t) {
  var i;
  if (
    !(e != null && e.sections) ||
    !((i = t == null ? void 0 : t.sections) != null && i.length) ||
    !t.sections_url
  )
    return;
  const n = {};
  t.sections.forEach((s) => {
    var a;
    const r = (a = e.sections) == null ? void 0 : a[s];
    typeof r == "string" &&
      (n[s] = { unparsedHtml: r, cachedAt: null, resultWasFromCache: !1 });
  });
  const o = {
    sections: t.sections,
    sections_url: t.sections_url,
    abortController: t.abortController,
    bypassCache: !0,
  };
  return { givenPayload: o, requestedPayload: o, results: n };
}
async function ze(e, t) {
  const n = _e(t) ?? t;
  try {
    N.publish("loading-bar:start", {});
    const o = await fetch(me[e], {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        credentials: "same-origin",
        body: JSON.stringify(n),
      }),
      i = await o.text();
    let s = null;
    if (i)
      try {
        s = JSON.parse(i);
      } catch (u) {
        console.warn("Cart API response was not valid JSON:", i, u);
      }
    if (!o.ok) {
      const u = {
        error: {
          title: window.IMPERIAL_THEME.translations.errors.cart.default_title,
          message:
            (s == null ? void 0 : s.description) ||
            window.IMPERIAL_THEME.translations.errors.unknown.default_message,
        },
        details: { failedAction: e, status: o.status },
      };
      return (N.publish("cart:onError", u), u);
    }
    if (!s) {
      const u = {
        error: {
          title:
            window.IMPERIAL_THEME.translations.errors.unknown.default_title,
          message:
            window.IMPERIAL_THEME.translations.errors.unknown.default_message,
        },
        details: { failedAction: e, status: o.status },
      };
      return (N.publish("cart:onError", u), u);
    }
    const r = Fe(s, n),
      a = Ot,
      c = await fe(),
      l = Be(a, c);
    if (((Ot = c), l)) {
      const u = {
        previous: a ?? null,
        current: c,
        ...(r && { sectionsRendered: r }),
      };
      N.publish("cart:onMutated", u);
    }
    return { ...s, ...(r && { sectionsRendered: r }) };
  } catch (o) {
    const i = {
      error: {
        title: window.IMPERIAL_THEME.translations.errors.unknown.default_title,
        message: `${(o == null ? void 0 : o.message) || ""} ${window.IMPERIAL_THEME.translations.errors.unknown.default_message}`,
      },
      details: { failedAction: e, status: "bad_request" },
    };
    return (N.publish("cart:onError", i), i);
  } finally {
    N.publish("loading-bar:end", {});
  }
}
async function pe(e) {
  return ze(e.action, e.payload);
}
async function Re() {
  const e = await fe();
  return ((Ot = e), e);
}
N.handleRequest("cart:mutate", (e) => pe(e));
N.subscribe("cart-note:change", (e) => {
  const t = { action: "update", payload: { note: e.currentNote } };
  pe(t);
});
N.handleRequest("cart:get", Re);
function je(e, t) {
  (e.appendChild(t),
    e.querySelectorAll("script").forEach((n) => {
      const o = document.createElement("script");
      (Array.from(n.attributes).forEach((i) => o.setAttribute(i.name, i.value)),
        (o.textContent = n.textContent),
        n.replaceWith(o));
    }));
}
function Ve(e) {
  return new Promise((t, n) => {
    const {
      remove: o,
      insert: i,
      beforeSwap: s = [],
      afterSwap: r = [],
      transitionClasses: a,
    } = e;
    if (!(o != null && o.parentNode))
      return n(new Error("Cannot replace node: remove.parentNode is null."));
    const c = i.cloneNode(!0),
      l = document.createElement("div");
    je(l, c);
    const u = l.firstElementChild;
    if (!u) return n(new Error("Failed to extract new node from wrapper."));
    s.forEach((d) => d(o, u));
    const m = Date.now();
    (o.querySelectorAll("[id], [form], input").forEach((d) => {
      if (!(d instanceof HTMLElement)) return;
      const y = d.getAttribute("id"),
        f = d.getAttribute("form");
      (y && d.setAttribute("id", `${y}-${m}`),
        f && d.setAttribute("form", `${f}-${m}`));
    }),
      o.parentNode.insertBefore(u, o),
      r.forEach((d) => d(o, u)),
      o.classList.add("hidden"),
      setTimeout(() => {
        (o.remove(), t(e));
      }, 0));
  });
}
N.handleRequest("html-swapper:swap", Ve);
const he = new Map();
function ge(e, t) {
  return JSON.stringify([e, t]);
}
function ke(e, t) {
  const n = ge(e, t);
  return he.get(n) || null;
}
function He(e, t, n) {
  const o = ge(e, t),
    i = { unparsedHtml: n, cachedAt: Date.now() };
  return (he.set(o, i), i);
}
function $e(e) {
  const t = new Map();
  for (const [o, i] of e.entries())
    (t.has(o) || t.set(o, []), t.get(o).push(i));
  const n = [];
  return (
    Array.from(t.entries())
      .sort(([o], [i]) => o.localeCompare(i))
      .forEach(([o, i]) => {
        (i.sort(), i.forEach((s) => n.push([o, s])));
      }),
    new URLSearchParams(n).toString()
  );
}
function Ge(e) {
  const t = e.replace(window.location.origin, ""),
    n = t.startsWith("/") ? t : "/" + t,
    o = new URL(n, window.location.origin),
    i = $e(o.searchParams);
  return ((o.search = i), o.pathname + (i ? `?${i}` : ""));
}
async function Qe(e) {
  var a;
  const n = {};
  let o = e.sections || [],
    i = Ge(e.sections_url || window.location.pathname);
  (e.bypassCache !== !0 &&
    o.forEach((c) => {
      const l = ke(c, i);
      l && (n[c] = { ...l, resultWasFromCache: !0 });
    }),
    (o = o.filter((c) => !n[c])),
    o.length > 5 &&
      console.warn(
        `Shopify Section Rendering API: Maximal 5 sections are allowed, ${o.length} have to be fetched. Sections will be chunked into groups of 5 and returned all at once. This may take longer than expected.`,
      ));
  const s = [];
  for (let c = 0; c < o.length; c += 5) s.push(o.slice(c, c + 5));
  const r = {};
  try {
    for (const l of s) {
      const u = new URL(i, window.location.origin);
      u.searchParams.set("sections", l.filter(Boolean).join(","));
      const m = u.pathname + u.search,
        d = await fetch(m, {
          signal: (a = e.abortController) == null ? void 0 : a.signal,
        });
      if (!d.ok)
        throw new Error(
          `Shopify Section Rendering API: Failed to render sections. Status: ${d.status}, URL: ${m}`,
        );
      const y = await d.json();
      Object.entries(y).forEach(([f, h]) => {
        h &&
          typeof h == "string" &&
          (r[f] = { ...He(f, i, h), resultWasFromCache: !1 });
      });
    }
    const c = {
      givenPayload: e,
      requestedPayload: {
        sections: o,
        sections_url: i,
        abortController: e.abortController,
        bypassCache: e.bypassCache,
      },
      results: { ...n, ...r },
    };
    return (N.publish("sections:onRendered", c), c);
  } catch (c) {
    const l = {
        givenPayload: e,
        requestedPayload: {
          sections: o,
          sections_url: i,
          abortController: e.abortController,
          bypassCache: e.bypassCache,
        },
        results: { ...n, ...r },
      },
      u = {
        error: {
          title:
            window.IMPERIAL_THEME.translations.errors.sections.default_title,
          message:
            window.IMPERIAL_THEME.translations.errors.sections.default_message,
        },
        details: {
          ...l,
          errorMessage:
            c instanceof Error
              ? c.message
              : "Unknown error occurred. Section rendering failed.",
        },
      };
    return (
      N.publish("sections:onRendered", l),
      N.publish("sections:onError", u),
      l
    );
  }
}
N.handleRequest("sections:render", Qe);
function mo(e, t) {
  const n = [];
  (e.filter(Boolean).forEach((i) => {
    const s = (
        (t == null ? void 0 : t.entering) ||
        i.getAttribute("entering") ||
        ""
      )
        .split(" ")
        .filter(Boolean),
      r = (
        (t == null ? void 0 : t.enteringFrom) ||
        i.getAttribute("entering-from") ||
        ""
      )
        .split(" ")
        .filter(Boolean),
      a = (
        (t == null ? void 0 : t.enteringTo) ||
        i.getAttribute("entering-to") ||
        ""
      )
        .split(" ")
        .filter(Boolean),
      c = ((t == null ? void 0 : t.leaving) || i.getAttribute("leaving") || "")
        .split(" ")
        .filter(Boolean),
      l = (
        (t == null ? void 0 : t.leavingFrom) ||
        i.getAttribute("leaving-from") ||
        ""
      )
        .split(" ")
        .filter(Boolean),
      u = (
        (t == null ? void 0 : t.leavingTo) ||
        i.getAttribute("leaving-to") ||
        ""
      )
        .split(" ")
        .filter(Boolean);
    (i.classList.remove(...c, ...l, ...u),
      i.classList.add(...s, ...r),
      n.push({ el: i, enteringFrom: r, enteringTo: a }));
  }),
    requestAnimationFrame(() => {
      n.forEach(({ el: i, enteringFrom: s, enteringTo: r }) => {
        (i.classList.remove(...s), i.classList.add(...r));
      });
    }));
}
function fo(e, t) {
  const n = [],
    o = e.filter(Boolean);
  return new Promise((i) => {
    (o.forEach((s) => {
      const r = (
          (t == null ? void 0 : t.entering) ||
          s.getAttribute("entering") ||
          ""
        )
          .split(" ")
          .filter(Boolean),
        a = (
          (t == null ? void 0 : t.enteringFrom) ||
          s.getAttribute("entering-from") ||
          ""
        )
          .split(" ")
          .filter(Boolean),
        c = (
          (t == null ? void 0 : t.enteringTo) ||
          s.getAttribute("entering-to") ||
          ""
        )
          .split(" ")
          .filter(Boolean),
        l = (
          (t == null ? void 0 : t.leaving) ||
          s.getAttribute("leaving") ||
          ""
        )
          .split(" ")
          .filter(Boolean),
        u = (
          (t == null ? void 0 : t.leavingFrom) ||
          s.getAttribute("leaving-from") ||
          ""
        )
          .split(" ")
          .filter(Boolean),
        m = (
          (t == null ? void 0 : t.leavingTo) ||
          s.getAttribute("leaving-to") ||
          ""
        )
          .split(" ")
          .filter(Boolean);
      (s.classList.remove(...r, ...a, ...c),
        s.classList.add(...l, ...u),
        n.push({ el: s, leavingFrom: u, leavingTo: m }));
    }),
      requestAnimationFrame(() => {
        let s = n.length;
        n.forEach(({ el: r, leavingFrom: a, leavingTo: c }) => {
          (r.classList.remove(...a), r.classList.add(...c));
          const l = (d) => {
            d.target === r &&
              (r.removeEventListener("transitionend", l), s--, s === 0 && i());
          };
          r.addEventListener("transitionend", l);
          const u = window.getComputedStyle(r);
          parseFloat(u.transitionDuration || "0") * 1e3 === 0 &&
            (r.removeEventListener("transitionend", l), s--, s === 0 && i());
        });
      }));
  });
}
function tn(e, t, n) {
  if (!n || Object.keys(n).length === 0)
    return e.isIntersecting && e.intersectionRatio >= t;
  const o = e.boundingClientRect,
    i = window.innerHeight,
    s = window.innerWidth,
    r = e.intersectionRatio >= t,
    a =
      (n.top === void 0 && n.bottom === void 0) ||
      (o.top >= (n.top ?? 0) && o.bottom <= i - (n.bottom ?? 0)),
    c =
      (n.left === void 0 && n.right === void 0) ||
      (o.left >= (n.left ?? 0) && o.right <= s - (n.right ?? 0));
  return a && c && r;
}
class en {
  constructor() {
    et(this, "observer", null);
    et(this, "mutationObserver", null);
    et(this, "elements", new Map());
  }
  initIntersectionObserver() {
    this.observer ||
      (this.observer = new IntersectionObserver(
        this.handleIntersect.bind(this),
        { threshold: 0, root: null, rootMargin: "0px" },
      ));
  }
  initMutationObserver() {
    this.mutationObserver ||
      ((this.mutationObserver = new MutationObserver(
        this.handleMutations.bind(this),
      )),
      this.mutationObserver.observe(document.body, {
        childList: !0,
        subtree: !0,
      }));
  }
  cleanupObserversIfEmpty() {
    var t, n;
    this.elements.size === 0 &&
      ((t = this.observer) == null || t.disconnect(),
      (this.observer = null),
      (n = this.mutationObserver) == null || n.disconnect(),
      (this.mutationObserver = null));
  }
  handleIntersect(t) {
    var n, o, i, s;
    for (const r of t) {
      const a = this.elements.get(r.target);
      if (!a) continue;
      const c = tn(r, a.threshold, a.elementOffset),
        l = {
          element: r.target,
          intersectionObserverEntry: r,
          enteredCount: a.enteredCount,
          leavedCount: a.leavedCount,
          isInside: a.isInside,
        };
      c
        ? a.isInside ||
          ((n = a.onEnter) == null || n.call(a, l),
          (o = N == null ? void 0 : N.publish) == null ||
            o.call(N, "viewport:onEntered", l),
          a.enteredCount++,
          (a.isInside = !0),
          a.triggerOnce && this.unsubscribe(r.target))
        : a.isInside &&
          !a.triggerOnce &&
          ((i = a.onLeave) == null || i.call(a, l),
          (s = N == null ? void 0 : N.publish) == null ||
            s.call(N, "viewport:onLeaved", l),
          a.leavedCount++,
          (a.isInside = !1));
    }
  }
  handleMutations(t) {
    for (const n of t)
      n.removedNodes.forEach((o) => {
        o instanceof Element && this.cleanupRemovedElement(o);
      });
  }
  cleanupRemovedElement(t) {
    this.elements.forEach((n, o) => {
      document.body.contains(o) || this.unsubscribe(o);
    });
  }
  subscribe(t, n) {
    (this.initIntersectionObserver(), this.initMutationObserver());
    const o = {
      el: t,
      onEnter: n.onEnter,
      onLeave: n.onLeave,
      threshold: n.threshold ?? 0,
      elementOffset: n.elementOffset,
      triggerOnce: n.triggerOnce ?? !1,
      enteredCount: 0,
      leavedCount: 0,
      isInside: !1,
    };
    return (
      this.elements.set(t, o),
      this.observer.observe(t),
      () => {
        this.unsubscribe(t);
      }
    );
  }
  unsubscribe(t) {
    var n;
    this.elements.has(t) &&
      ((n = this.observer) == null || n.unobserve(t),
      this.elements.delete(t),
      this.cleanupObserversIfEmpty());
  }
}
const Et = new en(),
  po = {
    subscribe: Et.subscribe.bind(Et),
    unsubscribe: Et.unsubscribe.bind(Et),
  };
class nn {
  constructor() {
    et(this, "readQueue", []);
    et(this, "writeQueue", []);
    et(this, "deferredReadQueue", []);
    et(this, "flushScheduled", !1);
    et(this, "flushing", !1);
    et(this, "layoutDirty", !1);
    et(this, "cleanPassScheduled", !1);
    et(this, "flushCount", 0);
    et(this, "cleanPassCount", 0);
    et(this, "inWritePhase", !1);
  }
  read(t) {
    return new Promise((n, o) => {
      const i = { kind: "read", task: t, resolve: n, reject: o };
      this.mustDeferReads()
        ? (this.deferredReadQueue.push(i), this.ensureCleanPassScheduled())
        : (this.readQueue.push(i), this.scheduleFlush());
    });
  }
  write(t) {
    return new Promise((n, o) => {
      const i = { kind: "write", task: t, resolve: n, reject: o };
      (this.writeQueue.push(i), this.scheduleFlush());
    });
  }
  getState() {
    return {
      flushScheduled: this.flushScheduled,
      flushing: this.flushing,
      layoutDirty: this.layoutDirty,
      cleanPassScheduled: this.cleanPassScheduled,
      flushCount: this.flushCount,
      cleanPassCount: this.cleanPassCount,
      pendingReads: this.readQueue.length,
      pendingWrites: this.writeQueue.length,
      pendingDeferredReads: this.deferredReadQueue.length,
    };
  }
  mustDeferReads() {
    return (
      this.writeQueue.length > 0 ||
      this.layoutDirty ||
      this.inWritePhase ||
      this.cleanPassScheduled
    );
  }
  scheduleFlush() {
    this.flushScheduled ||
      ((this.flushScheduled = !0),
      requestAnimationFrame(() => {
        this.flush();
      }));
  }
  ensureCleanPassScheduled() {
    this.cleanPassScheduled ||
      ((this.cleanPassScheduled = !0),
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          this.runCleanPass();
        });
      }));
  }
  flush() {
    if (!this.flushing) {
      ((this.flushing = !0),
        (this.flushScheduled = !1),
        (this.flushCount += 1));
      try {
        const t = this.readQueue.splice(0);
        for (const o of t) this.runJob(o);
        const n = this.writeQueue.splice(0);
        if (n.length > 0) {
          this.inWritePhase = !0;
          try {
            for (const o of n) this.runJob(o);
          } finally {
            this.inWritePhase = !1;
          }
          ((this.layoutDirty = !0), this.ensureCleanPassScheduled());
        }
      } finally {
        ((this.flushing = !1),
          (this.readQueue.length > 0 || this.writeQueue.length > 0) &&
            this.scheduleFlush());
      }
    }
  }
  runCleanPass() {
    if (
      ((this.cleanPassScheduled = !1),
      (this.cleanPassCount += 1),
      this.flushing ||
        this.flushScheduled ||
        this.writeQueue.length > 0 ||
        this.inWritePhase)
    ) {
      this.ensureCleanPassScheduled();
      return;
    }
    ((this.layoutDirty = !1),
      this.deferredReadQueue.length > 0 &&
        (this.readQueue.push(...this.deferredReadQueue.splice(0)),
        this.scheduleFlush()));
  }
  runJob(t) {
    try {
      const n = t.task();
      t.resolve(n);
    } catch (n) {
      t.reject(n);
    }
  }
}
const ho = new nn(),
  on = {
    active: !0,
    breakpoints: {},
    snapped: "is-snapped",
    inView: "is-in-view",
    draggable: "is-draggable",
    dragging: "is-dragging",
    loop: "is-loop",
  };
function Gt(e) {
  return (Array.isArray(e) ? e : [e]).filter(Boolean);
}
function Jt(e, t) {
  !e || !t.length || e.classList.remove(...t);
}
function St(e, t) {
  !e || !t.length || e.classList.add(...t);
}
function Je(e = {}) {
  let t,
    n,
    o,
    i,
    s = [],
    r = [];
  const a = ["select"],
    c = ["pointerDown", "pointerUp"],
    l = ["slidesInView"],
    u = { snapped: [], inView: [], draggable: [], dragging: [], loop: [] };
  function m(G, Z) {
    n = G;
    const { mergeOptions: S, optionsAtMedia: K } = Z,
      w = S(on, Je.globalOptions),
      U = S(w, e);
    ((t = K(U)), (o = n.rootNode()), (i = n.slideNodes()));
    const { watchDrag: W, loop: x } = n.internalEngine().options,
      M = !!W;
    (t.loop && x && ((u.loop = Gt(t.loop)), St(o, u.loop)),
      t.draggable && M && ((u.draggable = Gt(t.draggable)), St(o, u.draggable)),
      t.dragging &&
        ((u.dragging = Gt(t.dragging)), c.forEach((A) => n.on(A, y))),
      t.snapped &&
        ((u.snapped = Gt(t.snapped)), a.forEach((A) => n.on(A, h)), h()),
      t.inView &&
        ((u.inView = Gt(t.inView)), l.forEach((A) => n.on(A, J)), J()));
  }
  function d() {
    (c.forEach((G) => n.off(G, y)),
      a.forEach((G) => n.off(G, h)),
      l.forEach((G) => n.off(G, J)),
      Jt(o, u.loop),
      Jt(o, u.draggable),
      Jt(o, u.dragging),
      f([], s, u.snapped),
      f([], r, u.inView),
      Object.keys(u).forEach((G) => {
        const Z = G;
        u[Z] = [];
      }));
  }
  function y(G, Z) {
    (Z === "pointerDown" ? St : Jt)(o, u.dragging);
  }
  function f(G = [], Z = [], S) {
    const K = Z.map((U) => i[U]),
      w = G.map((U) => i[U]);
    return (K.forEach((U) => Jt(U, S)), w.forEach((U) => St(U, S)), G);
  }
  function h() {
    const { slideRegistry: G } = n.internalEngine(),
      Z = G[n.selectedScrollSnap()];
    s = f(Z, s, u.snapped);
  }
  function J() {
    const G = n.slidesInView();
    r = f(G, r, u.inView);
  }
  return { name: "classNames", options: e, init: m, destroy: d };
}
Je.globalOptions = void 0;
const rn = {
  active: !0,
  breakpoints: {},
  delay: 4e3,
  jump: !1,
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  stopOnLastSnap: !1,
  rootNode: null,
};
function sn(e, t) {
  const n = e.scrollSnapList();
  return typeof t == "number" ? n.map(() => t) : t(n, e);
}
function an(e, t) {
  const n = e.rootNode();
  return (t && t(n)) || n;
}
function ye(e = {}) {
  let t,
    n,
    o,
    i,
    s = null,
    r = 0,
    a = !1,
    c = !1,
    l = !1,
    u = !1;
  function m(p, v) {
    n = p;
    const { mergeOptions: X, optionsAtMedia: q } = v,
      C = X(rn, ye.globalOptions),
      b = X(C, e);
    if (((t = q(b)), n.scrollSnapList().length <= 1)) return;
    ((u = t.jump), (o = !1), (i = sn(n, t.delay)));
    const { eventStore: E, ownerDocument: I } = n.internalEngine(),
      D = !!n.internalEngine().options.watchDrag,
      T = an(n, t.rootNode);
    (E.add(I, "visibilitychange", g),
      D && n.on("pointerDown", Z),
      D && !t.stopOnInteraction && n.on("pointerUp", S),
      t.stopOnMouseEnter && E.add(T, "mouseenter", K),
      t.stopOnMouseEnter && !t.stopOnInteraction && E.add(T, "mouseleave", w),
      t.stopOnFocusIn && n.on("slideFocusStart", J),
      t.stopOnFocusIn &&
        !t.stopOnInteraction &&
        E.add(n.containerNode(), "focusout", h),
      t.playOnInit && h());
  }
  function d() {
    (n.off("pointerDown", Z).off("pointerUp", S).off("slideFocusStart", J),
      J(),
      (o = !0),
      (a = !1));
  }
  function y() {
    const { ownerWindow: p } = n.internalEngine();
    (p.clearTimeout(r),
      (r = p.setTimeout(A, i[n.selectedScrollSnap()])),
      (s = new Date().getTime()),
      n.emit("autoplay:timerset"));
  }
  function f() {
    const { ownerWindow: p } = n.internalEngine();
    (p.clearTimeout(r), (r = 0), (s = null), n.emit("autoplay:timerstopped"));
  }
  function h() {
    if (!o) {
      if (G()) {
        l = !0;
        return;
      }
      (a || n.emit("autoplay:play"), y(), (a = !0));
    }
  }
  function J() {
    o || (a && n.emit("autoplay:stop"), f(), (a = !1));
  }
  function g() {
    if (G()) return ((l = a), J());
    l && h();
  }
  function G() {
    const { ownerDocument: p } = n.internalEngine();
    return p.visibilityState === "hidden";
  }
  function Z() {
    c || J();
  }
  function S() {
    c || h();
  }
  function K() {
    ((c = !0), J());
  }
  function w() {
    ((c = !1), h());
  }
  function U(p) {
    (typeof p < "u" && (u = p), h());
  }
  function W() {
    a && J();
  }
  function x() {
    a && h();
  }
  function M() {
    return a;
  }
  function A() {
    const { index: p } = n.internalEngine(),
      v = p.clone().add(1).get(),
      X = n.scrollSnapList().length - 1,
      q = t.stopOnLastSnap && v === X;
    if (
      (n.canScrollNext() ? n.scrollNext(u) : n.scrollTo(0, u),
      n.emit("autoplay:select"),
      q)
    )
      return J();
    h();
  }
  function _() {
    if (!s) return null;
    const p = i[n.selectedScrollSnap()],
      v = new Date().getTime() - s;
    return p - v;
  }
  return {
    name: "autoplay",
    options: e,
    init: m,
    destroy: d,
    play: U,
    stop: W,
    reset: x,
    isPlaying: M,
    timeUntilNext: _,
  };
}
ye.globalOptions = void 0;
function cn(e = {}) {
  let t,
    n = [];
  const o = ["select", "slideFocus"];
  function i(l) {
    t = l;
    const {
      options: { axis: u },
      slideRects: m,
    } = t.internalEngine();
    u !== "y" &&
      ((n = m.map((d) => d.height)), o.forEach((d) => t.on(d, a)), a());
  }
  function s() {
    o.forEach((u) => t.off(u, a));
    const l = t.containerNode();
    ((l.style.height = ""),
      l.getAttribute("style") || l.removeAttribute("style"));
  }
  function r() {
    const { slideRegistry: l } = t.internalEngine(),
      u = l[t.selectedScrollSnap()];
    return u ? u.map((m) => n[m]).reduce((m, d) => Math.max(m, d), 0) : null;
  }
  function a() {
    r() !== null && (t.containerNode().style.height = `${r()}px`);
  }
  return { name: "autoHeight", options: e, init: i, destroy: s };
}
cn.globalOptions = void 0;
const ln = {
  direction: "forward",
  speed: 2,
  startDelay: 1e3,
  active: !0,
  breakpoints: {},
  playOnInit: !0,
  stopOnFocusIn: !0,
  stopOnInteraction: !0,
  stopOnMouseEnter: !1,
  rootNode: null,
};
function un(e, t) {
  const n = e.rootNode();
  return (t && t(n)) || n;
}
function ve(e = {}) {
  let t,
    n,
    o,
    i,
    s = 0,
    r = !1,
    a = !1,
    c;
  function l(x, M) {
    n = x;
    const { mergeOptions: A, optionsAtMedia: _ } = M,
      L = A(ln, ve.globalOptions),
      p = A(L, e);
    if (((t = _(p)), n.scrollSnapList().length <= 1)) return;
    ((i = t.startDelay), (o = !1), (c = n.internalEngine().scrollBody));
    const { eventStore: v } = n.internalEngine(),
      X = !!n.internalEngine().options.watchDrag,
      q = un(n, t.rootNode);
    (X && n.on("pointerDown", f),
      X && !t.stopOnInteraction && n.on("pointerUp", h),
      t.stopOnMouseEnter && v.add(q, "mouseenter", J),
      t.stopOnMouseEnter && !t.stopOnInteraction && v.add(q, "mouseleave", g),
      t.stopOnFocusIn && n.on("slideFocusStart", d),
      t.stopOnFocusIn &&
        !t.stopOnInteraction &&
        v.add(n.containerNode(), "focusout", m),
      t.playOnInit && m());
  }
  function u() {
    (n
      .off("pointerDown", f)
      .off("pointerUp", h)
      .off("slideFocusStart", d)
      .off("settle", G),
      d(),
      (o = !0),
      (r = !1));
  }
  function m() {
    if (o || r) return;
    n.emit("autoScroll:play");
    const x = n.internalEngine(),
      { ownerWindow: M } = x;
    ((s = M.setTimeout(() => {
      ((x.scrollBody = y(x)), x.animation.start());
    }, i)),
      (r = !0));
  }
  function d() {
    if (o || !r) return;
    n.emit("autoScroll:stop");
    const x = n.internalEngine(),
      { ownerWindow: M } = x;
    ((x.scrollBody = c), M.clearTimeout(s), (s = 0), (r = !1));
  }
  function y(x) {
    const {
        location: M,
        previousLocation: A,
        offsetLocation: _,
        target: L,
        scrollTarget: p,
        index: v,
        indexPrevious: X,
        limit: { reachedMin: q, reachedMax: C, constrain: b },
        options: { loop: E },
      } = x,
      I = t.direction === "forward" ? -1 : 1,
      D = () => H;
    let T = 0,
      B = 0,
      k = M.get(),
      Q = 0,
      R = !1;
    function j() {
      let $ = 0;
      (A.set(M),
        (T = I * t.speed),
        (k += T),
        M.add(T),
        L.set(M),
        ($ = k - Q),
        (B = Math.sign($)),
        (Q = k));
      const P = p.byDistance(0, !1).index;
      v.get() !== P && (X.set(v.get()), v.set(P), n.emit("select"));
      const Y = t.direction === "forward" ? q(_.get()) : C(_.get());
      if (!E && Y) {
        R = !0;
        const O = b(M.get());
        (M.set(O), L.set(M), d());
      }
      return H;
    }
    const H = {
      direction: () => B,
      duration: () => -1,
      velocity: () => T,
      settled: () => R,
      seek: j,
      useBaseFriction: D,
      useBaseDuration: D,
      useFriction: D,
      useDuration: D,
    };
    return H;
  }
  function f() {
    a || d();
  }
  function h() {
    a || Z();
  }
  function J() {
    ((a = !0), d());
  }
  function g() {
    ((a = !1), m());
  }
  function G() {
    (n.off("settle", G), m());
  }
  function Z() {
    n.on("settle", G);
  }
  function S(x) {
    (typeof x < "u" && (i = x), m());
  }
  function K() {
    r && d();
  }
  function w() {
    r && (d(), Z());
  }
  function U() {
    return r;
  }
  return {
    name: "autoScroll",
    options: e,
    init: l,
    destroy: u,
    play: S,
    stop: K,
    reset: w,
    isPlaying: U,
  };
}
ve.globalOptions = void 0;
function ee(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function At(e) {
  return typeof e == "number" && !isNaN(e);
}
function dn(e = {}) {
  let i,
    s = [],
    r,
    a = 0,
    c = 0,
    l = 0,
    u = !1,
    m,
    d;
  function y(p) {
    i = p;
    const v = i.selectedScrollSnap(),
      { scrollBody: X, containerRect: q, axis: C } = i.internalEngine(),
      b = C.measureSize(q);
    ((r = ee(b * 0.75, 200, 500)),
      (u = !1),
      (s = i.scrollSnapList().map((E, I) => (I === v ? 1 : 0))),
      (m = X.settled),
      (d = i.scrollProgress),
      (X.settled = A),
      (i.scrollProgress = _),
      i
        .on("select", G)
        .on("slideFocus", h)
        .on("pointerDown", g)
        .on("pointerUp", J),
      S(),
      h());
  }
  function f() {
    const { scrollBody: p } = i.internalEngine();
    ((p.settled = m),
      (i.scrollProgress = d),
      i
        .off("select", G)
        .off("slideFocus", h)
        .off("pointerDown", g)
        .off("pointerUp", J),
      i.slideNodes().forEach((v) => {
        const X = v.style;
        ((X.opacity = ""),
          (X.transform = ""),
          (X.pointerEvents = ""),
          v.getAttribute("style") || v.removeAttribute("style"));
      }));
  }
  function h() {
    const p = i.selectedScrollSnap();
    w(p, 1);
  }
  function J() {
    u = !1;
  }
  function g() {
    ((u = !1), (a = 0), (c = 0));
  }
  function G() {
    const p = i.internalEngine().scrollBody.duration();
    ((c = p ? 0 : 1), (u = !0), p || h());
  }
  function Z(p) {
    const { axis: v } = i.internalEngine();
    return `translate${v.scroll.toUpperCase()}(${v.direction(p)}px)`;
  }
  function S() {
    const { translate: p, slideLooper: v } = i.internalEngine();
    (p.clear(),
      p.toggleActive(!1),
      v.loopPoints.forEach(({ translate: X }) => {
        (X.clear(), X.toggleActive(!1));
      }));
  }
  function K(p) {
    const { scrollSnaps: v, location: X, target: q } = i.internalEngine();
    !At(p) || s[p] < 0.5 || (X.set(v[p]), q.set(X));
  }
  function w(p, v) {
    i.scrollSnapList().forEach((q, C) => {
      const b = Math.abs(v),
        E = s[C],
        I = C === p,
        D = I ? E + b : E - b,
        T = ee(D, 0, 1);
      s[C] = T;
      const B = I && u,
        k = i.previousScrollSnap();
      (B && (s[k] = 1 - T), I && W(p, T), U(C));
    });
  }
  function U(p) {
    const v = i.internalEngine().slideRegistry[p],
      { scrollSnaps: X, containerRect: q } = i.internalEngine(),
      C = s[p];
    v.forEach((b) => {
      const E = i.slideNodes()[b].style,
        I = parseFloat(C.toFixed(2)),
        D = I > 0,
        T = D ? X[p] : q.width + 2,
        B = Z(T);
      (D && (E.transform = B),
        (E.opacity = I.toString()),
        (E.pointerEvents = C > 0.5 ? "auto" : "none"),
        D || (E.transform = B));
    });
  }
  function W(p, v) {
    const { index: X, dragHandler: q, scrollSnaps: C } = i.internalEngine(),
      b = q.pointerDown(),
      E = 1 / (C.length - 1);
    let I = p,
      D = b ? i.selectedScrollSnap() : i.previousScrollSnap();
    if (b && I === D) {
      const k = Math.sign(a) * -1;
      ((I = D), (D = X.clone().set(D).add(k).get()));
    }
    const T = D * E,
      B = (I - D) * E;
    l = T + B * v;
  }
  function x() {
    const { dragHandler: p, index: v, scrollBody: X } = i.internalEngine(),
      q = i.selectedScrollSnap();
    if (!p.pointerDown()) return q;
    const C = Math.sign(X.velocity()),
      b = Math.sign(a),
      E = v
        .clone()
        .set(q)
        .add(C * -1)
        .get();
    return !C || !b ? null : b === C ? E : q;
  }
  function M(p) {
    const { dragHandler: v, scrollBody: X } = p.internalEngine(),
      q = v.pointerDown(),
      C = X.velocity(),
      b = X.duration(),
      E = x(),
      I = !At(E);
    if (q) {
      if (!C) return;
      ((a += C), (c = Math.abs(C / r)), K(E));
    }
    if (!q) {
      if (!b || I) return;
      ((c += (1 - s[E]) / b), (c *= 0.68));
    }
    I || w(E, c);
  }
  function A() {
    const { target: p, location: v } = i.internalEngine(),
      X = p.get() - v.get(),
      q = Math.abs(X) >= 1,
      C = x(),
      b = !At(C);
    return (M(i), b || q ? !1 : s[C] > 0.999);
  }
  function _() {
    return l;
  }
  return { name: "fade", options: e, init: y, destroy: f };
}
dn.globalOptions = void 0;
function lt() {
  return (
    (lt =
      Object.assign ||
      function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = arguments[t];
          for (var o in n)
            Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
        return e;
      }),
    lt.apply(this, arguments)
  );
}
var mn = 0.996,
  fn = function (t, n) {
    return (n === void 0 && (n = mn), (t * n) / (1 - n));
  };
function pn(e) {
  return e[e.length - 1];
}
function hn(e) {
  return (
    e.reduce(function (t, n) {
      return t + n;
    }) / e.length
  );
}
var gn = function (t, n, o) {
  return Math.min(Math.max(n, t), o);
};
function Dt(e, t) {
  if (e.length !== t.length) throw new Error("vectors must be same length");
  return e.map(function (n, o) {
    return n + t[o];
  });
}
function ne(e) {
  return Math.max.apply(Math, e.map(Math.abs));
}
function pt(e) {
  return (
    Object.freeze(e),
    Object.values(e).forEach(function (t) {
      t !== null && typeof t == "object" && !Object.isFrozen(t) && pt(t);
    }),
    e
  );
}
function Gn() {
  var e = {};
  function t(i, s) {
    return (
      (e[i] = (e[i] || []).concat(s)),
      function () {
        return n(i, s);
      }
    );
  }
  function n(i, s) {
    e[i] = (e[i] || []).filter(function (r) {
      return r !== s;
    });
  }
  function o(i, s) {
    i in e &&
      e[i].forEach(function (r) {
        return r(s);
      });
  }
  return pt({ on: t, off: n, dispatch: o });
}
function Jn(e) {
  var t = [],
    n = function (r) {
      return (
        r.addEventListener("wheel", e, { passive: !1 }),
        t.push(r),
        function () {
          return o(r);
        }
      );
    },
    o = function (r) {
      (r.removeEventListener("wheel", e),
        (t = t.filter(function (a) {
          return a !== r;
        })));
    },
    i = function () {
      t.forEach(o);
    };
  return pt({ observe: n, unobserve: o, disconnect: i });
}
var yn = 16 * 1.125,
  vn = (typeof window < "u" && window.innerHeight) || 800,
  Lt = [1, yn, vn];
function Zn(e) {
  var t = e.deltaX * Lt[e.deltaMode],
    n = e.deltaY * Lt[e.deltaMode],
    o = (e.deltaZ || 0) * Lt[e.deltaMode];
  return { timeStamp: e.timeStamp, axisDelta: [t, n, o] };
}
var bn = [-1, -1, -1];
function Xn(e, t) {
  if (!t) return e;
  var n =
    t === !0
      ? bn
      : t.map(function (o) {
          return o ? -1 : 1;
        });
  return lt({}, e, {
    axisDelta: e.axisDelta.map(function (o, i) {
      return o * n[i];
    }),
  });
}
var Yn = 700,
  Un = function (t) {
    return lt({}, t, {
      axisDelta: t.axisDelta.map(function (n) {
        return gn(n, -700, Yn);
      }),
    });
  },
  xn = 0.6,
  En = 0.96,
  Sn = 2,
  oe = 5,
  ie = pt({ preventWheelAction: !0, reverseSign: [!0, !0, !1] }),
  In = 400;
function re() {
  return {
    isStarted: !1,
    isStartPublished: !1,
    isMomentum: !1,
    startTime: 0,
    lastAbsDelta: 1 / 0,
    axisMovement: [0, 0, 0],
    axisVelocity: [0, 0, 0],
    accelerationFactors: [],
    scrollPoints: [],
    scrollPointsToMerge: [],
    willEndTimeout: In,
  };
}
function wn(e) {
  e === void 0 && (e = {});
  var t = Gn(),
    n = t.on,
    o = t.off,
    i = t.dispatch,
    s = ie,
    r = re(),
    a,
    c = !1,
    l,
    u = function (p) {
      Array.isArray(p)
        ? p.forEach(function (v) {
            return f(v);
          })
        : f(p);
    },
    m = function (p) {
      return (
        p === void 0 && (p = {}),
        Object.values(p).some(function (v) {
          return v == null;
        })
          ? s
          : (s = pt(lt({}, ie, s, p)))
      );
    },
    d = function (p) {
      var v = lt(
        {
          event: a,
          isStart: !1,
          isEnding: !1,
          isMomentumCancel: !1,
          isMomentum: r.isMomentum,
          axisDelta: [0, 0, 0],
          axisVelocity: r.axisVelocity,
          axisMovement: r.axisMovement,
          get axisMovementProjection() {
            return Dt(
              v.axisMovement,
              v.axisVelocity.map(function (X) {
                return fn(X);
              }),
            );
          },
        },
        p,
      );
      (i("wheel", lt({}, v, { previous: l })), (l = v));
    },
    y = function (p, v) {
      var X = s,
        q = X.preventWheelAction,
        C = v[0],
        b = v[1],
        E = v[2];
      if (typeof q == "boolean") return q;
      switch (q) {
        case "x":
          return Math.abs(C) >= p;
        case "y":
          return Math.abs(b) >= p;
        case "z":
          return Math.abs(E) >= p;
        default:
          return !1;
      }
    },
    f = function (p) {
      var v = Un(Xn(Zn(p), s.reverseSign)),
        X = v.axisDelta,
        q = v.timeStamp,
        C = ne(X);
      if (
        (p.preventDefault && y(C, X) && p.preventDefault(),
        r.isStarted
          ? r.isMomentum && C > Math.max(2, r.lastAbsDelta * 2) && (W(!0), w())
          : w(),
        C === 0 && Object.is && Object.is(p.deltaX, -0))
      ) {
        c = !0;
        return;
      }
      ((a = p),
        (r.axisMovement = Dt(r.axisMovement, X)),
        (r.lastAbsDelta = C),
        r.scrollPointsToMerge.push({ axisDelta: X, timeStamp: q }),
        h(),
        d({ axisDelta: X, isStart: !r.isStartPublished }),
        (r.isStartPublished = !0),
        U());
    },
    h = function () {
      r.scrollPointsToMerge.length === Sn
        ? (r.scrollPoints.unshift({
            axisDeltaSum: r.scrollPointsToMerge
              .map(function (p) {
                return p.axisDelta;
              })
              .reduce(Dt),
            timeStamp: hn(
              r.scrollPointsToMerge.map(function (p) {
                return p.timeStamp;
              }),
            ),
          }),
          g(),
          (r.scrollPointsToMerge.length = 0),
          (r.scrollPoints.length = 1),
          r.isMomentum || S())
        : r.isStartPublished || J();
    },
    J = function () {
      r.axisVelocity = pn(r.scrollPointsToMerge).axisDelta.map(function (p) {
        return p / r.willEndTimeout;
      });
    },
    g = function () {
      var p = r.scrollPoints,
        v = p[0],
        X = p[1];
      if (!(!X || !v)) {
        var q = v.timeStamp - X.timeStamp;
        if (!(q <= 0)) {
          var C = v.axisDeltaSum.map(function (E) {
              return E / q;
            }),
            b = C.map(function (E, I) {
              return E / (r.axisVelocity[I] || 1);
            });
          ((r.axisVelocity = C), r.accelerationFactors.push(b), G(q));
        }
      }
    },
    G = function (p) {
      var v = Math.ceil(p / 10) * 10 * 1.2;
      (r.isMomentum || (v = Math.max(100, v * 2)),
        (r.willEndTimeout = Math.min(1e3, Math.round(v))));
    },
    Z = function (p) {
      return p === 0 ? !0 : p <= En && p >= xn;
    },
    S = function () {
      if (r.accelerationFactors.length >= oe) {
        if (c && ((c = !1), ne(r.axisVelocity) >= 0.2)) {
          K();
          return;
        }
        var p = r.accelerationFactors.slice(oe * -1),
          v = p.every(function (X) {
            var q = !!X.reduce(function (b, E) {
                return b && b < 1 && b === E ? 1 : 0;
              }),
              C = X.filter(Z).length === X.length;
            return q || C;
          });
        (v && K(), (r.accelerationFactors = p));
      }
    },
    K = function () {
      r.isMomentum = !0;
    },
    w = function () {
      ((r = re()),
        (r.isStarted = !0),
        (r.startTime = Date.now()),
        (l = void 0),
        (c = !1));
    },
    U = (function () {
      var L;
      return function () {
        (clearTimeout(L), (L = setTimeout(W, r.willEndTimeout)));
      };
    })(),
    W = function (p) {
      (p === void 0 && (p = !1),
        r.isStarted &&
          (r.isMomentum && p
            ? d({ isEnding: !0, isMomentumCancel: !0 })
            : d({ isEnding: !0 }),
          (r.isMomentum = !1),
          (r.isStarted = !1)));
    },
    x = Jn(u),
    M = x.observe,
    A = x.unobserve,
    _ = x.disconnect;
  return (
    m(e),
    pt({
      on: n,
      off: o,
      observe: M,
      unobserve: A,
      disconnect: _,
      feedWheel: u,
      updateOptions: m,
    })
  );
}
var Cn = {
  active: !0,
  breakpoints: {},
  wheelDraggingClass: "is-wheel-dragging",
  forceWheelAxis: void 0,
  target: void 0,
};
Ze.globalOptions = void 0;
function Ze(e) {
  e === void 0 && (e = {});
  var t,
    n = function () {};
  function o(s, r) {
    var a,
      c,
      l = r.mergeOptions,
      u = r.optionsAtMedia,
      m = l(Cn, Ze.globalOptions),
      d = l(m, e);
    t = u(d);
    var y = s.internalEngine(),
      f = (a = t.target) != null ? a : s.containerNode().parentNode,
      h = (c = t.forceWheelAxis) != null ? c : y.options.axis,
      J = wn({ preventWheelAction: h, reverseSign: [!0, !0, !1] });
    function g() {
      U = (h === "x" ? y.containerRect.width : y.containerRect.height) / 2;
    }
    var G = J.observe(f),
      Z = J.on("wheel", C),
      S = !1,
      K,
      w = 0,
      U = 0,
      W = !1;
    (g(), s.on("resize", g));
    function x(b) {
      try {
        ((K = new MouseEvent("mousedown", b.event)), v(K));
      } catch {
        return n();
      }
      ((S = !0),
        (w = 0),
        A(),
        t.wheelDraggingClass && f.classList.add(t.wheelDraggingClass));
    }
    function M(b) {
      ((S = !1),
        v(p("mouseup", b)),
        _(),
        t.wheelDraggingClass && f.classList.remove(t.wheelDraggingClass));
    }
    function A() {
      (document.documentElement.addEventListener("mousemove", L, !0),
        document.documentElement.addEventListener("mouseup", L, !0),
        document.documentElement.addEventListener("mousedown", L, !0));
    }
    function _() {
      (document.documentElement.removeEventListener("mousemove", L, !0),
        document.documentElement.removeEventListener("mouseup", L, !0),
        document.documentElement.removeEventListener("mousedown", L, !0));
    }
    function L(b) {
      S && b.isTrusted && b.stopImmediatePropagation();
    }
    function p(b, E) {
      var I, D;
      if (h === y.options.axis) {
        var T = E.axisMovement;
        ((I = T[0]), (D = T[1]));
      } else {
        var B = E.axisMovement;
        ((D = B[0]), (I = B[1]));
      }
      var k = X(E),
        Q = k.isAtBoundary;
      if (Q) {
        var R = Math.min(w / U, 1),
          j = 0.25 + R * 0.5,
          H = I > 0 ? -1 : 1,
          $ = w * H,
          P = $ * j;
        ((I += P), (D += P));
      }
      if (!y.options.skipSnaps && !y.options.dragFree) {
        var Y = y.containerRect.width,
          O = y.containerRect.height;
        ((I = I < 0 ? Math.max(I, -Y) : Math.min(I, Y)),
          (D = D < 0 ? Math.max(D, -O) : Math.min(D, O)));
      }
      return new MouseEvent(b, {
        clientX: K.clientX + I,
        clientY: K.clientY + D,
        screenX: K.screenX + I,
        screenY: K.screenY + D,
        movementX: I,
        movementY: D,
        button: 0,
        bubbles: !0,
        cancelable: !0,
        composed: !0,
      });
    }
    function v(b) {
      s.containerNode().dispatchEvent(b);
    }
    function X(b) {
      var E = b.axisDelta,
        I = E[0],
        D = E[1],
        T = s.scrollProgress(),
        B = T < 1,
        k = T > 0,
        Q = h === "x" ? I : D,
        R = Q < 0,
        j = Q > 0,
        H = (R && !B) || (j && !k);
      return { isAtBoundary: H, primaryAxisDelta: Q };
    }
    function q(b) {
      var E = X(b),
        I = E.isAtBoundary,
        D = E.primaryAxisDelta;
      if (I && !b.isMomentum) {
        if (((w += Math.abs(D)), w > U)) return ((W = !0), M(b), !0);
      } else w = 0;
      return !1;
    }
    function C(b) {
      var E = b.axisDelta,
        I = E[0],
        D = E[1],
        T = h === "x" ? I : D,
        B = h === "x" ? D : I,
        k = b.isMomentum && b.previous && !b.previous.isMomentum,
        Q = (b.isEnding && !b.isMomentum) || k,
        R = Math.abs(T) > Math.abs(B);
      (R && !S && !b.isMomentum && !W && x(b),
        W && b.isEnding && (W = !1),
        S && (q(b) || (Q ? M(b) : v(p("mousemove", b)))));
    }
    n = function () {
      (G(), Z(), s.off("resize", g), _());
    };
  }
  var i = {
    name: "wheelGestures",
    options: e,
    init: o,
    destroy: function () {
      return n();
    },
  };
  return i;
}
function _t(e) {
  return typeof e == "number";
}
function Tt(e) {
  return typeof e == "string";
}
function wt(e) {
  return typeof e == "boolean";
}
function se(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function z(e) {
  return Math.abs(e);
}
function Nt(e) {
  return Math.sign(e);
}
function Zt(e, t) {
  return z(e - t);
}
function qn(e, t) {
  if (e === 0 || t === 0 || z(e) <= z(t)) return 0;
  const n = Zt(z(e), z(t));
  return z(n / e);
}
function Wn(e) {
  return Math.round(e * 100) / 100;
}
function bt(e) {
  return Xt(e).map(Number);
}
function nt(e) {
  return e[Ut(e)];
}
function Ut(e) {
  return Math.max(0, e.length - 1);
}
function Bt(e, t) {
  return t === Ut(e);
}
function ae(e, t = 0) {
  return Array.from(Array(e), (n, o) => t + o);
}
function Xt(e) {
  return Object.keys(e);
}
function be(e, t) {
  return [e, t].reduce(
    (n, o) => (
      Xt(o).forEach((i) => {
        const s = n[i],
          r = o[i],
          a = se(s) && se(r);
        n[i] = a ? be(s, r) : r;
      }),
      n
    ),
    {},
  );
}
function Pt(e, t) {
  return typeof t.MouseEvent < "u" && e instanceof t.MouseEvent;
}
function Kn(e, t) {
  const n = { start: o, center: i, end: s };
  function o() {
    return 0;
  }
  function i(c) {
    return s(c) / 2;
  }
  function s(c) {
    return t - c;
  }
  function r(c, l) {
    return Tt(e) ? n[e](c) : e(t, c, l);
  }
  return { measure: r };
}
function Yt() {
  let e = [];
  function t(i, s, r, a = { passive: !0 }) {
    let c;
    if ("addEventListener" in i)
      (i.addEventListener(s, r, a), (c = () => i.removeEventListener(s, r, a)));
    else {
      const l = i;
      (l.addListener(r), (c = () => l.removeListener(r)));
    }
    return (e.push(c), o);
  }
  function n() {
    e = e.filter((i) => i());
  }
  const o = { add: t, clear: n };
  return o;
}
function Mn(e, t, n, o) {
  const i = Yt(),
    s = 1e3 / 60;
  let r = null,
    a = 0,
    c = 0;
  function l() {
    i.add(e, "visibilitychange", () => {
      e.hidden && f();
    });
  }
  function u() {
    (y(), i.clear());
  }
  function m(J) {
    if (!c) return;
    r || ((r = J), n(), n());
    const g = J - r;
    for (r = J, a += g; a >= s; ) (n(), (a -= s));
    const G = a / s;
    (o(G), c && (c = t.requestAnimationFrame(m)));
  }
  function d() {
    c || (c = t.requestAnimationFrame(m));
  }
  function y() {
    (t.cancelAnimationFrame(c), (r = null), (a = 0), (c = 0));
  }
  function f() {
    ((r = null), (a = 0));
  }
  return { init: l, destroy: u, start: d, stop: y, update: n, render: o };
}
function An(e, t) {
  const n = t === "rtl",
    o = e === "y",
    i = o ? "y" : "x",
    s = o ? "x" : "y",
    r = !o && n ? -1 : 1,
    a = u(),
    c = m();
  function l(f) {
    const { height: h, width: J } = f;
    return o ? h : J;
  }
  function u() {
    return o ? "top" : n ? "right" : "left";
  }
  function m() {
    return o ? "bottom" : n ? "left" : "right";
  }
  function d(f) {
    return f * r;
  }
  return {
    scroll: i,
    cross: s,
    startEdge: a,
    endEdge: c,
    measureSize: l,
    direction: d,
  };
}
function ut(e = 0, t = 0) {
  const n = z(e - t);
  function o(l) {
    return l < e;
  }
  function i(l) {
    return l > t;
  }
  function s(l) {
    return o(l) || i(l);
  }
  function r(l) {
    return s(l) ? (o(l) ? e : t) : l;
  }
  function a(l) {
    return n ? l - n * Math.ceil((l - t) / n) : l;
  }
  return {
    length: n,
    max: t,
    min: e,
    constrain: r,
    reachedAny: s,
    reachedMax: i,
    reachedMin: o,
    removeOffset: a,
  };
}
function Xe(e, t, n) {
  const { constrain: o } = ut(0, e),
    i = e + 1;
  let s = r(t);
  function r(d) {
    return n ? z((i + d) % i) : o(d);
  }
  function a() {
    return s;
  }
  function c(d) {
    return ((s = r(d)), m);
  }
  function l(d) {
    return u().set(a() + d);
  }
  function u() {
    return Xe(e, a(), n);
  }
  const m = { get: a, set: c, add: l, clone: u };
  return m;
}
function Dn(e, t, n, o, i, s, r, a, c, l, u, m, d, y, f, h, J, g, G) {
  const { cross: Z, direction: S } = e,
    K = ["INPUT", "SELECT", "TEXTAREA"],
    w = { passive: !1 },
    U = Yt(),
    W = Yt(),
    x = ut(50, 225).constrain(y.measure(20)),
    M = { mouse: 300, touch: 400 },
    A = { mouse: 500, touch: 600 },
    _ = f ? 43 : 25;
  let L = !1,
    p = 0,
    v = 0,
    X = !1,
    q = !1,
    C = !1,
    b = !1;
  function E(Y) {
    if (!G) return;
    function O(tt) {
      (wt(G) || G(Y, tt)) && Q(tt);
    }
    const V = t;
    U.add(V, "dragstart", (tt) => tt.preventDefault(), w)
      .add(V, "touchmove", () => {}, w)
      .add(V, "touchend", () => {})
      .add(V, "touchstart", O)
      .add(V, "mousedown", O)
      .add(V, "touchcancel", j)
      .add(V, "contextmenu", j)
      .add(V, "click", H, !0);
  }
  function I() {
    (U.clear(), W.clear());
  }
  function D() {
    const Y = b ? n : t;
    W.add(Y, "touchmove", R, w)
      .add(Y, "touchend", j)
      .add(Y, "mousemove", R, w)
      .add(Y, "mouseup", j);
  }
  function T(Y) {
    const O = Y.nodeName || "";
    return K.includes(O);
  }
  function B() {
    return (f ? A : M)[b ? "mouse" : "touch"];
  }
  function k(Y, O) {
    const V = m.add(Nt(Y) * -1),
      tt = u.byDistance(Y, !f).distance;
    return f || z(Y) < x
      ? tt
      : J && O
        ? tt * 0.5
        : u.byIndex(V.get(), 0).distance;
  }
  function Q(Y) {
    const O = Pt(Y, o);
    ((b = O),
      (C = f && O && !Y.buttons && L),
      (L = Zt(i.get(), r.get()) >= 2),
      !(O && Y.button !== 0) &&
        (T(Y.target) ||
          ((X = !0),
          s.pointerDown(Y),
          l.useFriction(0).useDuration(0),
          i.set(r),
          D(),
          (p = s.readPoint(Y)),
          (v = s.readPoint(Y, Z)),
          d.emit("pointerDown"))));
  }
  function R(Y) {
    if (!Pt(Y, o) && Y.touches.length >= 2) return j(Y);
    const V = s.readPoint(Y),
      tt = s.readPoint(Y, Z),
      ot = Zt(V, p),
      it = Zt(tt, v);
    if (!q && !b && (!Y.cancelable || ((q = ot > it), !q))) return j(Y);
    const at = s.pointerMove(Y);
    (ot > h && (C = !0),
      l.useFriction(0.3).useDuration(0.75),
      a.start(),
      i.add(S(at)),
      Y.preventDefault());
  }
  function j(Y) {
    const V = u.byDistance(0, !1).index !== m.get(),
      tt = s.pointerUp(Y) * B(),
      ot = k(S(tt), V),
      it = qn(tt, ot),
      at = _ - 10 * it,
      st = g + it / 50;
    ((q = !1),
      (X = !1),
      W.clear(),
      l.useDuration(at).useFriction(st),
      c.distance(ot, !f),
      (b = !1),
      d.emit("pointerUp"));
  }
  function H(Y) {
    C && (Y.stopPropagation(), Y.preventDefault(), (C = !1));
  }
  function $() {
    return X;
  }
  return { init: E, destroy: I, pointerDown: $ };
}
function Ln(e, t) {
  let o, i;
  function s(m) {
    return m.timeStamp;
  }
  function r(m, d) {
    const f = `client${(d || e.scroll) === "x" ? "X" : "Y"}`;
    return (Pt(m, t) ? m : m.touches[0])[f];
  }
  function a(m) {
    return ((o = m), (i = m), r(m));
  }
  function c(m) {
    const d = r(m) - r(i),
      y = s(m) - s(o) > 170;
    return ((i = m), y && (o = m), d);
  }
  function l(m) {
    if (!o || !i) return 0;
    const d = r(i) - r(o),
      y = s(m) - s(o),
      f = s(m) - s(i) > 170,
      h = d / y;
    return y && !f && z(h) > 0.1 ? h : 0;
  }
  return { pointerDown: a, pointerMove: c, pointerUp: l, readPoint: r };
}
function On() {
  function e(n) {
    const { offsetTop: o, offsetLeft: i, offsetWidth: s, offsetHeight: r } = n;
    return {
      top: o,
      right: i + s,
      bottom: o + r,
      left: i,
      width: s,
      height: r,
    };
  }
  return { measure: e };
}
function Tn(e) {
  function t(o) {
    return e * (o / 100);
  }
  return { measure: t };
}
function Pn(e, t, n, o, i, s, r) {
  const a = [e].concat(o);
  let c,
    l,
    u = [],
    m = !1;
  function d(J) {
    return i.measureSize(r.measure(J));
  }
  function y(J) {
    if (!s) return;
    ((l = d(e)), (u = o.map(d)));
    function g(G) {
      for (const Z of G) {
        if (m) return;
        const S = Z.target === e,
          K = o.indexOf(Z.target),
          w = S ? l : u[K],
          U = d(S ? e : o[K]);
        if (z(U - w) >= 0.5) {
          (J.reInit(), t.emit("resize"));
          break;
        }
      }
    }
    ((c = new ResizeObserver((G) => {
      (wt(s) || s(J, G)) && g(G);
    })),
      n.requestAnimationFrame(() => {
        a.forEach((G) => c.observe(G));
      }));
  }
  function f() {
    ((m = !0), c && c.disconnect());
  }
  return { init: y, destroy: f };
}
function _n(e, t, n, o, i, s) {
  let r = 0,
    a = 0,
    c = i,
    l = s,
    u = e.get(),
    m = 0;
  function d() {
    const w = o.get() - e.get(),
      U = !c;
    let W = 0;
    return (
      U
        ? ((r = 0), n.set(o), e.set(o), (W = w))
        : (n.set(e), (r += w / c), (r *= l), (u += r), e.add(r), (W = u - m)),
      (a = Nt(W)),
      (m = u),
      K
    );
  }
  function y() {
    const w = o.get() - t.get();
    return z(w) < 0.001;
  }
  function f() {
    return c;
  }
  function h() {
    return a;
  }
  function J() {
    return r;
  }
  function g() {
    return Z(i);
  }
  function G() {
    return S(s);
  }
  function Z(w) {
    return ((c = w), K);
  }
  function S(w) {
    return ((l = w), K);
  }
  const K = {
    direction: h,
    duration: f,
    velocity: J,
    seek: d,
    settled: y,
    useBaseFriction: G,
    useBaseDuration: g,
    useFriction: S,
    useDuration: Z,
  };
  return K;
}
function Nn(e, t, n, o, i) {
  const s = i.measure(10),
    r = i.measure(50),
    a = ut(0.1, 0.99);
  let c = !1;
  function l() {
    return !(c || !e.reachedAny(n.get()) || !e.reachedAny(t.get()));
  }
  function u(y) {
    if (!l()) return;
    const f = e.reachedMin(t.get()) ? "min" : "max",
      h = z(e[f] - t.get()),
      J = n.get() - t.get(),
      g = a.constrain(h / r);
    (n.subtract(J * g),
      !y &&
        z(J) < s &&
        (n.set(e.constrain(n.get())), o.useDuration(25).useBaseFriction()));
  }
  function m(y) {
    c = !y;
  }
  return { shouldConstrain: l, constrain: u, toggleActive: m };
}
function Bn(e, t, n, o, i) {
  const s = ut(-t + e, 0),
    r = m(),
    a = u(),
    c = d();
  function l(f, h) {
    return Zt(f, h) <= 1;
  }
  function u() {
    const f = r[0],
      h = nt(r),
      J = r.lastIndexOf(f),
      g = r.indexOf(h) + 1;
    return ut(J, g);
  }
  function m() {
    return n
      .map((f, h) => {
        const { min: J, max: g } = s,
          G = s.constrain(f),
          Z = !h,
          S = Bt(n, h);
        return Z ? g : S || l(J, G) ? J : l(g, G) ? g : G;
      })
      .map((f) => parseFloat(f.toFixed(3)));
  }
  function d() {
    if (t <= e + i) return [s.max];
    if (o === "keepSnaps") return r;
    const { min: f, max: h } = a;
    return r.slice(f, h);
  }
  return { snapsContained: c, scrollContainLimit: a };
}
function Fn(e, t, n) {
  const o = t[0],
    i = n ? o - e : nt(t);
  return { limit: ut(i, o) };
}
function zn(e, t, n, o) {
  const s = t.min + 0.1,
    r = t.max + 0.1,
    { reachedMin: a, reachedMax: c } = ut(s, r);
  function l(d) {
    return d === 1 ? c(n.get()) : d === -1 ? a(n.get()) : !1;
  }
  function u(d) {
    if (!l(d)) return;
    const y = e * (d * -1);
    o.forEach((f) => f.add(y));
  }
  return { loop: u };
}
function Rn(e) {
  const { max: t, length: n } = e;
  function o(s) {
    const r = s - t;
    return n ? r / -n : 0;
  }
  return { get: o };
}
function jn(e, t, n, o, i) {
  const { startEdge: s, endEdge: r } = e,
    { groupSlides: a } = i,
    c = m().map(t.measure),
    l = d(),
    u = y();
  function m() {
    return a(o)
      .map((h) => nt(h)[r] - h[0][s])
      .map(z);
  }
  function d() {
    return o.map((h) => n[s] - h[s]).map((h) => -z(h));
  }
  function y() {
    return a(l)
      .map((h) => h[0])
      .map((h, J) => h + c[J]);
  }
  return { snaps: l, snapsAligned: u };
}
function Vn(e, t, n, o, i, s) {
  const { groupSlides: r } = i,
    { min: a, max: c } = o,
    l = u();
  function u() {
    const d = r(s),
      y = !e || t === "keepSnaps";
    return n.length === 1
      ? [s]
      : y
        ? d
        : d.slice(a, c).map((f, h, J) => {
            const g = !h,
              G = Bt(J, h);
            if (g) {
              const Z = nt(J[0]) + 1;
              return ae(Z);
            }
            if (G) {
              const Z = Ut(s) - nt(J)[0] + 1;
              return ae(Z, nt(J)[0]);
            }
            return f;
          });
  }
  return { slideRegistry: l };
}
function kn(e, t, n, o, i) {
  const { reachedAny: s, removeOffset: r, constrain: a } = o;
  function c(f) {
    return f.concat().sort((h, J) => z(h) - z(J))[0];
  }
  function l(f) {
    const h = e ? r(f) : a(f),
      J = t
        .map((G, Z) => ({ diff: u(G - h, 0), index: Z }))
        .sort((G, Z) => z(G.diff) - z(Z.diff)),
      { index: g } = J[0];
    return { index: g, distance: h };
  }
  function u(f, h) {
    const J = [f, f + n, f - n];
    if (!e) return f;
    if (!h) return c(J);
    const g = J.filter((G) => Nt(G) === h);
    return g.length ? c(g) : nt(J) - n;
  }
  function m(f, h) {
    const J = t[f] - i.get(),
      g = u(J, h);
    return { index: f, distance: g };
  }
  function d(f, h) {
    const J = i.get() + f,
      { index: g, distance: G } = l(J),
      Z = !e && s(J);
    if (!h || Z) return { index: g, distance: f };
    const S = t[g] - G,
      K = f + u(S, 0);
    return { index: g, distance: K };
  }
  return { byDistance: d, byIndex: m, shortcut: u };
}
function Hn(e, t, n, o, i, s, r) {
  function a(m) {
    const d = m.distance,
      y = m.index !== t.get();
    (s.add(d),
      d && (o.duration() ? e.start() : (e.update(), e.render(1), e.update())),
      y && (n.set(t.get()), t.set(m.index), r.emit("select")));
  }
  function c(m, d) {
    const y = i.byDistance(m, d);
    a(y);
  }
  function l(m, d) {
    const y = t.clone().set(m),
      f = i.byIndex(y.get(), d);
    a(f);
  }
  return { distance: c, index: l };
}
function $n(e, t, n, o, i, s, r, a) {
  const c = { passive: !0, capture: !0 };
  let l = 0;
  function u(y) {
    if (!a) return;
    function f(h) {
      if (new Date().getTime() - l > 10) return;
      (r.emit("slideFocusStart"), (e.scrollLeft = 0));
      const G = n.findIndex((Z) => Z.includes(h));
      _t(G) && (i.useDuration(0), o.index(G, 0), r.emit("slideFocus"));
    }
    (s.add(document, "keydown", m, !1),
      t.forEach((h, J) => {
        s.add(
          h,
          "focus",
          (g) => {
            (wt(a) || a(y, g)) && f(J);
          },
          c,
        );
      }));
  }
  function m(y) {
    y.code === "Tab" && (l = new Date().getTime());
  }
  return { init: u };
}
function vt(e) {
  let t = e;
  function n() {
    return t;
  }
  function o(c) {
    t = r(c);
  }
  function i(c) {
    t += r(c);
  }
  function s(c) {
    t -= r(c);
  }
  function r(c) {
    return _t(c) ? c : c.get();
  }
  return { get: n, set: o, add: i, subtract: s };
}
function Ye(e, t) {
  const n = e.scroll === "x" ? r : a,
    o = t.style;
  let i = null,
    s = !1;
  function r(d) {
    return `translate3d(${d}px,0px,0px)`;
  }
  function a(d) {
    return `translate3d(0px,${d}px,0px)`;
  }
  function c(d) {
    if (s) return;
    const y = Wn(e.direction(d));
    y !== i && ((o.transform = n(y)), (i = y));
  }
  function l(d) {
    s = !d;
  }
  function u() {
    s ||
      ((o.transform = ""),
      t.getAttribute("style") || t.removeAttribute("style"));
  }
  return { clear: u, to: c, toggleActive: l };
}
function Qn(e, t, n, o, i, s, r, a, c) {
  const u = bt(i),
    m = bt(i).reverse(),
    d = g().concat(G());
  function y(U, W) {
    return U.reduce((x, M) => x - i[M], W);
  }
  function f(U, W) {
    return U.reduce((x, M) => (y(x, W) > 0 ? x.concat([M]) : x), []);
  }
  function h(U) {
    return s.map((W, x) => ({
      start: W - o[x] + 0.5 + U,
      end: W + t - 0.5 + U,
    }));
  }
  function J(U, W, x) {
    const M = h(W);
    return U.map((A) => {
      const _ = x ? 0 : -n,
        L = x ? n : 0,
        p = x ? "end" : "start",
        v = M[A][p];
      return {
        index: A,
        loopPoint: v,
        slideLocation: vt(-1),
        translate: Ye(e, c[A]),
        target: () => (a.get() > v ? _ : L),
      };
    });
  }
  function g() {
    const U = r[0],
      W = f(m, U);
    return J(W, n, !1);
  }
  function G() {
    const U = t - r[0] - 1,
      W = f(u, U);
    return J(W, -n, !0);
  }
  function Z() {
    return d.every(({ index: U }) => {
      const W = u.filter((x) => x !== U);
      return y(W, t) <= 0.1;
    });
  }
  function S() {
    d.forEach((U) => {
      const { target: W, translate: x, slideLocation: M } = U,
        A = W();
      A !== M.get() && (x.to(A), M.set(A));
    });
  }
  function K() {
    d.forEach((U) => U.translate.clear());
  }
  return { canLoop: Z, clear: K, loop: S, loopPoints: d };
}
function to(e, t, n) {
  let o,
    i = !1;
  function s(c) {
    if (!n) return;
    function l(u) {
      for (const m of u)
        if (m.type === "childList") {
          (c.reInit(), t.emit("slidesChanged"));
          break;
        }
    }
    ((o = new MutationObserver((u) => {
      i || ((wt(n) || n(c, u)) && l(u));
    })),
      o.observe(e, { childList: !0 }));
  }
  function r() {
    (o && o.disconnect(), (i = !0));
  }
  return { init: s, destroy: r };
}
function eo(e, t, n, o) {
  const i = {};
  let s = null,
    r = null,
    a,
    c = !1;
  function l() {
    ((a = new IntersectionObserver(
      (f) => {
        c ||
          (f.forEach((h) => {
            const J = t.indexOf(h.target);
            i[J] = h;
          }),
          (s = null),
          (r = null),
          n.emit("slidesInView"));
      },
      { root: e.parentElement, threshold: o },
    )),
      t.forEach((f) => a.observe(f)));
  }
  function u() {
    (a && a.disconnect(), (c = !0));
  }
  function m(f) {
    return Xt(i).reduce((h, J) => {
      const g = parseInt(J),
        { isIntersecting: G } = i[g];
      return (((f && G) || (!f && !G)) && h.push(g), h);
    }, []);
  }
  function d(f = !0) {
    if (f && s) return s;
    if (!f && r) return r;
    const h = m(f);
    return (f && (s = h), f || (r = h), h);
  }
  return { init: l, destroy: u, get: d };
}
function no(e, t, n, o, i, s) {
  const { measureSize: r, startEdge: a, endEdge: c } = e,
    l = n[0] && i,
    u = f(),
    m = h(),
    d = n.map(r),
    y = J();
  function f() {
    if (!l) return 0;
    const G = n[0];
    return z(t[a] - G[a]);
  }
  function h() {
    if (!l) return 0;
    const G = s.getComputedStyle(nt(o));
    return parseFloat(G.getPropertyValue(`margin-${c}`));
  }
  function J() {
    return n
      .map((G, Z, S) => {
        const K = !Z,
          w = Bt(S, Z);
        return K ? d[Z] + u : w ? d[Z] + m : S[Z + 1][a] - G[a];
      })
      .map(z);
  }
  return { slideSizes: d, slideSizesWithGaps: y, startGap: u, endGap: m };
}
function oo(e, t, n, o, i, s, r, a, c) {
  const { startEdge: l, endEdge: u, direction: m } = e,
    d = _t(n);
  function y(g, G) {
    return bt(g)
      .filter((Z) => Z % G === 0)
      .map((Z) => g.slice(Z, Z + G));
  }
  function f(g) {
    return g.length
      ? bt(g)
          .reduce((G, Z, S) => {
            const K = nt(G) || 0,
              w = K === 0,
              U = Z === Ut(g),
              W = i[l] - s[K][l],
              x = i[l] - s[Z][u],
              M = !o && w ? m(r) : 0,
              A = !o && U ? m(a) : 0,
              _ = z(x - A - (W + M));
            return (S && _ > t + c && G.push(Z), U && G.push(g.length), G);
          }, [])
          .map((G, Z, S) => {
            const K = Math.max(S[Z - 1] || 0);
            return g.slice(K, G);
          })
      : [];
  }
  function h(g) {
    return d ? y(g, n) : f(g);
  }
  return { groupSlides: h };
}
function io(e, t, n, o, i, s, r) {
  const {
      align: a,
      axis: c,
      direction: l,
      startIndex: u,
      loop: m,
      duration: d,
      dragFree: y,
      dragThreshold: f,
      inViewThreshold: h,
      slidesToScroll: J,
      skipSnaps: g,
      containScroll: G,
      watchResize: Z,
      watchSlides: S,
      watchDrag: K,
      watchFocus: w,
    } = s,
    U = 2,
    W = On(),
    x = W.measure(t),
    M = n.map(W.measure),
    A = An(c, l),
    _ = A.measureSize(x),
    L = Tn(_),
    p = Kn(a, _),
    v = !m && !!G,
    X = m || !!G,
    {
      slideSizes: q,
      slideSizesWithGaps: C,
      startGap: b,
      endGap: E,
    } = no(A, x, M, n, X, i),
    I = oo(A, _, J, m, x, M, b, E, U),
    { snaps: D, snapsAligned: T } = jn(A, p, x, M, I),
    B = -nt(D) + nt(C),
    { snapsContained: k, scrollContainLimit: Q } = Bn(_, B, T, G, U),
    R = v ? k : T,
    { limit: j } = Fn(B, R, m),
    H = Xe(Ut(R), u, m),
    $ = H.clone(),
    P = bt(n),
    Y = ({
      dragHandler: dt,
      scrollBody: Kt,
      scrollBounds: Mt,
      options: { loop: xt },
    }) => {
      (xt || Mt.constrain(dt.pointerDown()), Kt.seek());
    },
    O = (
      {
        scrollBody: dt,
        translate: Kt,
        location: Mt,
        offsetLocation: xt,
        previousLocation: Se,
        scrollLooper: Ie,
        slideLooper: we,
        dragHandler: Ce,
        animation: qe,
        eventHandler: jt,
        scrollBounds: We,
        options: { loop: Vt },
      },
      kt,
    ) => {
      const Ht = dt.settled(),
        Ke = !We.shouldConstrain(),
        $t = Vt ? Ht : Ht && Ke,
        Qt = $t && !Ce.pointerDown();
      Qt && qe.stop();
      const Me = Mt.get() * kt + Se.get() * (1 - kt);
      (xt.set(Me),
        Vt && (Ie.loop(dt.direction()), we.loop()),
        Kt.to(xt.get()),
        Qt && jt.emit("settle"),
        $t || jt.emit("scroll"));
    },
    V = Mn(
      o,
      i,
      () => Y(Wt),
      (dt) => O(Wt, dt),
    ),
    tt = 0.68,
    ot = R[H.get()],
    it = vt(ot),
    at = vt(ot),
    st = vt(ot),
    ct = vt(ot),
    ht = _n(it, st, at, ct, d, tt),
    Ct = kn(m, R, B, j, ct),
    qt = Hn(V, H, $, ht, Ct, ct, r),
    Ft = Rn(j),
    zt = Yt(),
    xe = eo(t, n, r, h),
    { slideRegistry: Rt } = Vn(v, G, R, Q, I, P),
    Ee = $n(e, n, Rt, qt, ht, zt, r, w),
    Wt = {
      ownerDocument: o,
      ownerWindow: i,
      eventHandler: r,
      containerRect: x,
      slideRects: M,
      animation: V,
      axis: A,
      dragHandler: Dn(
        A,
        e,
        o,
        i,
        ct,
        Ln(A, i),
        it,
        V,
        qt,
        ht,
        Ct,
        H,
        r,
        L,
        y,
        f,
        g,
        tt,
        K,
      ),
      eventStore: zt,
      percentOfView: L,
      index: H,
      indexPrevious: $,
      limit: j,
      location: it,
      offsetLocation: st,
      previousLocation: at,
      options: s,
      resizeHandler: Pn(t, r, i, n, A, Z, W),
      scrollBody: ht,
      scrollBounds: Nn(j, st, ct, ht, L),
      scrollLooper: zn(B, j, st, [it, st, at, ct]),
      scrollProgress: Ft,
      scrollSnapList: R.map(Ft.get),
      scrollSnaps: R,
      scrollTarget: Ct,
      scrollTo: qt,
      slideLooper: Qn(A, _, B, q, C, D, R, st, n),
      slideFocus: Ee,
      slidesHandler: to(t, r, S),
      slidesInView: xe,
      slideIndexes: P,
      slideRegistry: Rt,
      slidesToScroll: I,
      target: ct,
      translate: Ye(A, t),
    };
  return Wt;
}
function ro() {
  let e = {},
    t;
  function n(l) {
    t = l;
  }
  function o(l) {
    return e[l] || [];
  }
  function i(l) {
    return (o(l).forEach((u) => u(t, l)), c);
  }
  function s(l, u) {
    return ((e[l] = o(l).concat([u])), c);
  }
  function r(l, u) {
    return ((e[l] = o(l).filter((m) => m !== u)), c);
  }
  function a() {
    e = {};
  }
  const c = { init: n, emit: i, off: r, on: s, clear: a };
  return c;
}
const so = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0,
};
function ao(e) {
  function t(s, r) {
    return be(s, r || {});
  }
  function n(s) {
    const r = s.breakpoints || {},
      a = Xt(r)
        .filter((c) => e.matchMedia(c).matches)
        .map((c) => r[c])
        .reduce((c, l) => t(c, l), {});
    return t(s, a);
  }
  function o(s) {
    return s
      .map((r) => Xt(r.breakpoints || {}))
      .reduce((r, a) => r.concat(a), [])
      .map(e.matchMedia);
  }
  return { mergeOptions: t, optionsAtMedia: n, optionsMediaQueries: o };
}
function co(e) {
  let t = [];
  function n(s, r) {
    return (
      (t = r.filter(({ options: a }) => e.optionsAtMedia(a).active !== !1)),
      t.forEach((a) => a.init(s, e)),
      r.reduce((a, c) => Object.assign(a, { [c.name]: c }), {})
    );
  }
  function o() {
    t = t.filter((s) => s.destroy());
  }
  return { init: n, destroy: o };
}
function Ue(e, t, n) {
  const o = e.ownerDocument,
    i = o.defaultView,
    s = ao(i),
    r = co(s),
    a = Yt(),
    c = ro(),
    { mergeOptions: l, optionsAtMedia: u, optionsMediaQueries: m } = s,
    { on: d, off: y, emit: f } = c,
    h = A;
  let J = !1,
    g,
    G = l(so, Ue.globalOptions),
    Z = l(G),
    S = [],
    K,
    w,
    U;
  function W() {
    const { container: P, slides: Y } = Z;
    w = (Tt(P) ? e.querySelector(P) : P) || e.children[0];
    const V = Tt(Y) ? w.querySelectorAll(Y) : Y;
    U = [].slice.call(V || w.children);
  }
  function x(P) {
    const Y = io(e, w, U, o, i, P, c);
    if (P.loop && !Y.slideLooper.canLoop()) {
      const O = Object.assign({}, P, { loop: !1 });
      return x(O);
    }
    return Y;
  }
  function M(P, Y) {
    J ||
      ((G = l(G, P)),
      (Z = u(G)),
      (S = Y || S),
      W(),
      (g = x(Z)),
      m([G, ...S.map(({ options: O }) => O)]).forEach((O) =>
        a.add(O, "change", A),
      ),
      Z.active &&
        (g.translate.to(g.location.get()),
        g.animation.init(),
        g.slidesInView.init(),
        g.slideFocus.init($),
        g.eventHandler.init($),
        g.resizeHandler.init($),
        g.slidesHandler.init($),
        g.options.loop && g.slideLooper.loop(),
        w.offsetParent && U.length && g.dragHandler.init($),
        (K = r.init($, S))));
  }
  function A(P, Y) {
    const O = I();
    (_(), M(l({ startIndex: O }, P), Y), c.emit("reInit"));
  }
  function _() {
    (g.dragHandler.destroy(),
      g.eventStore.clear(),
      g.translate.clear(),
      g.slideLooper.clear(),
      g.resizeHandler.destroy(),
      g.slidesHandler.destroy(),
      g.slidesInView.destroy(),
      g.animation.destroy(),
      r.destroy(),
      a.clear());
  }
  function L() {
    J || ((J = !0), a.clear(), _(), c.emit("destroy"), c.clear());
  }
  function p(P, Y, O) {
    !Z.active ||
      J ||
      (g.scrollBody.useBaseFriction().useDuration(Y === !0 ? 0 : Z.duration),
      g.scrollTo.index(P, O || 0));
  }
  function v(P) {
    const Y = g.index.add(1).get();
    p(Y, P, -1);
  }
  function X(P) {
    const Y = g.index.add(-1).get();
    p(Y, P, 1);
  }
  function q() {
    return g.index.add(1).get() !== I();
  }
  function C() {
    return g.index.add(-1).get() !== I();
  }
  function b() {
    return g.scrollSnapList;
  }
  function E() {
    return g.scrollProgress.get(g.offsetLocation.get());
  }
  function I() {
    return g.index.get();
  }
  function D() {
    return g.indexPrevious.get();
  }
  function T() {
    return g.slidesInView.get();
  }
  function B() {
    return g.slidesInView.get(!1);
  }
  function k() {
    return K;
  }
  function Q() {
    return g;
  }
  function R() {
    return e;
  }
  function j() {
    return w;
  }
  function H() {
    return U;
  }
  const $ = {
    canScrollNext: q,
    canScrollPrev: C,
    containerNode: j,
    internalEngine: Q,
    destroy: L,
    off: y,
    on: d,
    emit: f,
    plugins: k,
    previousScrollSnap: D,
    reInit: h,
    rootNode: R,
    scrollNext: v,
    scrollPrev: X,
    scrollProgress: E,
    scrollSnapList: b,
    scrollTo: p,
    selectedScrollSnap: I,
    slideNodes: H,
    slidesInView: T,
    slidesNotInView: B,
  };
  return (M(t, n), setTimeout(() => c.emit("init"), 0), $);
}
Ue.globalOptions = void 0;
customElements.get("inline-svg-from-img") ||
  customElements.define(
    "inline-svg-from-img",
    class extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        if (this.hasAttribute("svg-processed")) return;
        this.setAttribute("svg-processed", "");
        const t = this.querySelector("img");
        if (!t) return;
        const n = t.getAttribute("src");
        if (!n) return;
        const o = [...t.classList];
        (t.remove(),
          fetch(n)
            .then((i) => i.text())
            .then((i) => {
              const s = new DOMParser()
                .parseFromString(i, "image/svg+xml")
                .querySelector("svg");
              s &&
                (s.classList.add(...o),
                N.request("html-swapper:swap", { remove: this, insert: s }));
            }));
      }
    },
  );
(function (e, t) {
  const n = rt,
    o = e();
  for (;;)
    try {
      if (
        (parseInt(n(260)) / 1) * (-parseInt(n(271)) / 2) +
          (-parseInt(n(262)) / 3) * (parseInt(n(276)) / 4) +
          (-parseInt(n(272)) / 5) * (parseInt(n(282)) / 6) +
          (-parseInt(n(259)) / 7) * (parseInt(n(278)) / 8) +
          (-parseInt(n(265)) / 9) * (-parseInt(n(280)) / 10) +
          (parseInt(n(264)) / 11) * (parseInt(n(257)) / 12) +
          parseInt(n(279)) / 13 ===
        t
      )
        break;
      o.push(o.shift());
    } catch {
      o.push(o.shift());
    }
})(It, 958222);
function lo() {
  const e = rt,
    t = {};
  ((t.XBUyH = function (o, i) {
    return o !== i;
  }),
    (t.jDRAA = e(263)));
  const n = t;
  (n.XBUyH(typeof window, n[e(274)]) && (window[e(285)].PUBSUB = N),
    document[e(258)](e(286), () => {
      const o = e,
        i = window.Shopify;
      i &&
        console[o(266)](
          o(270) +
            (i[o(268)][o(267)] || o(269))[o(261)]() +
            o(275) +
            (i.theme.schema_version || "?") +
            o(284),
          o(281),
          o(277),
          o(283),
          `
        color: red;
        font-size: 12px;
        `,
          `
        font-size: 12px;
        `,
          o(273),
        );
    }));
}
function rt(e, t) {
  e = e - 257;
  const n = It();
  let o = n[e];
  if (rt.haBCnr === void 0) {
    var i = function (c) {
      const l =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=";
      let u = "",
        m = "";
      for (
        let d = 0, y, f, h = 0;
        (f = c.charAt(h++));
        ~f && ((y = d % 4 ? y * 64 + f : f), d++ % 4)
          ? (u += String.fromCharCode(255 & (y >> ((-2 * d) & 6))))
          : 0
      )
        f = l.indexOf(f);
      for (let d = 0, y = u.length; d < y; d++)
        m += "%" + ("00" + u.charCodeAt(d).toString(16)).slice(-2);
      return decodeURIComponent(m);
    };
    ((rt.jVlSTz = i), (rt.UWNdCM = {}), (rt.haBCnr = !0));
  }
  const s = n[0],
    r = e + s,
    a = rt.UWNdCM[r];
  return (a ? (o = a) : ((o = rt.jVlSTz(o)), (rt.UWNdCM[r] = o)), o);
}
function It() {
  const e = [
    "DgHLBwu",
    "su1qrvjjquW",
    "jwmGjwmk",
    "mtreExbKEM4",
    "odbJqxLNq08",
    "cIaGicaGicaGCgfKzgLUzY10B3a6ideWChG7cIaGicaGicaGzM9UDc1ZAxPLoIaXmhb4oWOGicaGicaGia",
    "AKrsque",
    "ifrOzw1LicH2",
    "nJaXmJrKuKXRq0m",
    "cIaGicaGicaGyM9YzgvYlxrVCdOGmxb4ihnVBgLKicm3qtK5qum7cIaGicaGicaGy29SB3i6icmWmei1rti7cIaGicaGicaGCgfKzgLUzY10B3a6ideWChG7cIaGicaGicaGzM9UDc1ZAxPLoIaXnhb4oWOGicaGicaGigzVBNqTD2vPz2H0oIbIB2XKzxi7cIaGicaGicaG",
    "odqYntq0og9Are51rq",
    "nJiYntG0mtDVyxP4uxm",
    "mZaWmJa3mfPKrvHQqG",
    "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",
    "mte4mdaYDKjHAM5u",
    "cIaGicaGicaGCgfKzgLUzY10B3a6idvWEdSkicaGicaGicbMB250lxnPEMu6ideYChG7cIaGicaGicaG",
    "ksbIEsbiqvnilunptsbhBwjiicvJcKvUz2LUzwvYzwqGD2L0AcaLy+kzPsvJigLUieDLCM1HBNKkjwnmzwfYBIbTB3jLoIbODhrWCZOVl2HHC2GTy29TlMrL",
    "su1qrvjjquXFveHftuu",
    "re9nq29UDgvUDeXVywrLza",
    "mJqZnZjxuwzdsMG",
    "ywrKrxzLBNrmAxn0zw5LCG",
    "n2LOC21zyW",
    "mtq2mZu5serNsuvu",
    "Dg9vChbLCKnHC2u",
    "mZyWBMjVywzm",
    "Dw5KzwzPBMvK",
    "mZuYEurhwhfL",
    "ouH0rg9KBG",
    "Bg9N",
    "C2nOzw1Hx25HBwu",
  ];
  return (
    (It = function () {
      return e;
    }),
    It()
  );
}
lo();
export {
  ve as A,
  Je as C,
  ho as D,
  Ue as E,
  dn as F,
  N as P,
  Ze as W,
  fo as a,
  mo as b,
  cn as c,
  ye as d,
  po as v,
};
